import React from "react";
import bookcover from "../assets/goldilocks-thumbnail.jpg";

export const Header = ({ title = "Naomi Lovelace Timeline", quote }) => {
  return (
    <header>
      <div className="header-container">
        <div>
          <h1 className="title">{title}</h1>
          <em className="quote">"{quote}"</em>
        </div>
        <a
          href="http://www.lauralam.co.uk/book/goldilocks/"
          className="cover-thumb"
        >
          <img src={bookcover} alt="Goldilocks book cover" />
        </a>
      </div>
      <div className="line" />
    </header>
  );
};
